import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses')({
  beforeLoad: () => getTitleContextSlice('Tickets Statuses'),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
